import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { Portal } from 'react-portal'
import { connect } from 'redaction'
import { getScrollBarWidth, getPageOffset } from 'common/helpers'
import { toArray } from 'lodash'

import Modals from 'components/modals'

import s from './ModalConductor.scss'


class ModalConductor extends Component {

  static propTypes = {
    modals: PropTypes.object, // @connect
  }

  rootNode = null
  offsetTop = 0

  componentDidMount() {
    this.rootNode = document.getElementById('root')
  }

  UNSAFE_componentWillReceiveProps({ modals }) {
    // When modal is showing add overflow: hidden to body and padding-right: ${scrollWidth}
    // to prevent screen from blinking
    if (Object.keys(modals).length) {
      const offsetTop = getPageOffset().y

      document.body.classList.add('body-modal-opened')
      document.body.style.paddingRight = `${getScrollBarWidth()}px`

      if (offsetTop > 0) {
        window.scrollTo(0, 0)
        this.translateRoot(-offsetTop)
        this.offsetTop = offsetTop
      }
    }
    else {
      document.body.classList.remove('body-modal-opened')
      document.body.style.paddingRight = '0px'

      if (this.offsetTop > 0) {
        this.translateRoot(0)
        window.scrollTo(0, this.offsetTop)
        this.offsetTop = 0
      }
    }
  }

  translateRoot(offset) {
    this.rootNode.style.transform = offset ? `translate3d(0, ${offset}px, 0)` : 'none'
    this.rootNode.style.webkitTransform = offset ? `translate3d(0, ${offset}px, 0)` : 'none'
  }

  render() {
    const { modals }  = this.props
    const baseZIndex  = 501 // 501 bcs there is Overlay on 500

    return (
      <Portal>
        <Fragment>
          {
            toArray(modals).map(({ name, data = {}, zIndex }) => {
              const modal = Modals[name]

              if (!modal) {
                console.error(`Can not find a modal named "${name}"!`)
                return null
              }

              return (
                <div key={name} className={s.modalConductor} style={{ zIndex: baseZIndex + zIndex }}>
                  {
                    React.createElement(modal, { data })
                  }
                </div>
              )
            })
          }
        </Fragment>
      </Portal>
    )
  }
}


export default connect({
  modals: 'models.modals',
})(ModalConductor)
